import React from "react";
import { Icons, IconButton, Tooltip } from "@curves/ui-base";

const SmsActionBar = props => {
	const { getResult: getResultProps = () => {}, dialogRef, refresh: refreshProps } = props;

	const handleClick = () => {
		const targetData = getResultProps();
		if (dialogRef && dialogRef.current && targetData.length !== 0) dialogRef.current.openNonMemberSmsDialog(targetData, refreshProps);
	};

	return (
		<Tooltip title={"寄送簡訊"}>
			<IconButton onClick={handleClick}>
				<Icons.PaperPlane />
			</IconButton>
		</Tooltip>
	);
};

export default SmsActionBar;
